import React, { useEffect, useState } from "react";
import styles from "./TableView.module.scss";
import { indicatorList } from "Explore/Config/FilterConfig";

const fmtRaw = (num) => {
  if (num == null) return "—";
  if (Math.abs(num) >= 1e9) return (num / 1e9).toFixed(1) + "B";
  if (Math.abs(num) >= 1e6) return (num / 1e6).toFixed(1) + "M";
  if (Math.abs(num) >= 1e3) return Math.round(num / 1e3) + "K";
  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
};

const getAbbreviation = (name) => {
  const skip = new Set(["of", "the", "at", "and", "–"]);
  return name
    .split(/[\s,]+/)
    .filter(Boolean)
    .filter((w) => !skip.has(w.toLowerCase()))
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 3);
};

const indicatorLabelMap = indicatorList.reduce((acc, indicator) => {
  acc[indicator.value] = indicator.label;
  return acc;
}, {});

const InstitutionLogo = ({ photoUrl, fallbackText }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    setFailed(false);
  }, [photoUrl]);
  if (photoUrl && !failed) {
    return (
      <img
        src={photoUrl}
        alt=""
        className={styles["table-view__logo-img"]}
        loading="lazy"
        onError={() => setFailed(true)}
      />
    );
  }
  return <div className={styles["table-view__logo"]}>{fallbackText}</div>;
};

const getIndicatorValue = (item, indicator) => {
  const value = item?.indicators?.[indicator];
  if (
    indicator === "international_collaborations" &&
    value &&
    typeof value === "object"
  ) {
    return value.total_collaborations ?? "—";
  }
  return value;
};

const TableView = ({
  data,
  selectedIndicators = [],
  selectedInstitutions = [],
  onToggle,
}) => {
  const visibleIndicators = selectedIndicators.length
    ? selectedIndicators
    : ["total_publications"];

  return (
    <div className={styles["table-view"]}>
      <table>
        <thead>
          <tr className={styles["table-view__col-header"]}>
            <th className={styles["table-view__checkbox"]}></th>
            <th>Rank</th>
            <th>University</th>
            {visibleIndicators.map((indicator) => (
              <th key={indicator}>{indicatorLabelMap[indicator] || indicator}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, idx) => {
            const abbr = getAbbreviation(item.institution_name);
            const isSelected = selectedInstitutions.some(
              (inst) => inst.institution_id === item.institution_id
            );

            return (
              <tr key={item.institution_id} className={styles["table-view__row"]}>
                <td className={styles["table-view__checkbox"]}>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => onToggle(item)}
                  />
                </td>

                <td className={styles["table-view__rank"]}>#{idx + 1}</td>

                <td className={styles["table-view__university"]}>
                  <div className={styles["table-view__university-info"]}>
                    <InstitutionLogo
                      photoUrl={item.institution_photo_url}
                      fallbackText={abbr}
                    />
                    <div className={styles["table-view__uni-text"]}>
                      <span className={styles["table-view__uni-name"]}>
                        {item.institution_name}
                      </span>
                    </div>
                  </div>
                </td>

                {visibleIndicators.map((indicator) => (
                  <td key={`${item.institution_id}-${indicator}`} className={styles["table-view__num"]}>
                    {fmtRaw(getIndicatorValue(item, indicator))}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default TableView;
